module.exports = __webpack_public_path__ + "img/bk.1b3d7f74.png";